export class SystemPhaseDetail {
    SystemPhaseName: string = "";
    DisplayOrder: number = 1;
    AnchorDays: number = 0;
    Status: boolean = true;
    IsActualEditable: boolean = true;
}